export const Types = {
    TOGGLE: 'header/TOGGLE',
}

const INITIAL_STATE = {
    open: false,
}

export default function header(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.TOGGLE: {
            return { ...state, open: !state.open };
        }
        default:
            return false;
    }
};

export const Creators = {
    toggle: () => ({
        type: Types.TOGGLE,
    })
}